<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template >
<div class="relative pb-32" :key="componentKey">
  <Pagesubtitle subTitle="Customize your language & tone."/>
  <p class="text-sm text-light mb-1">SELECT LANGUAGE PACK</p>
  <div class="vx-row">
    <div class="vx-col w-full lg:w-1/2">
      <v-select placeholder="Select language..." class="w-full bg-white ptlargerselect mb-4" style="z-index: 10000;" size="large" :searchable="false" :clearable="false" :options="translations" label="name" :reduce="pack => pack.i" v-model="translationI" /></div>
    <div class="vx-col w-full lg:w-1/2">
      <vs-button class="w-1/2 lg:w-4/12 lg:mr-1" @click="customizeThis" v-if="!translations[translationI].isCustom">Customize ></vs-button>
      <vs-button class="w-1/2 lg:w-6/12" type="border" href="mailto:support@feedback.link?subject=Request new language translation for Feedback Link">Request translation</vs-button>
    </div>
  </div>
  <div v-if="!formsDisabled && $store.state.dash.isMulti" class="mb-4 flex items-center">
    <feather-icon icon="InfoIcon" svgClasses="stroke-current text-light w-6 h-6" class="mx-2" />
    <span class="inline-block max-w-lg text-light">Language packs can be reused across spaces. To create a unique language pack for a space, select an official translation (i.e. "English" or "Italian") and click "Customize >".</span>
  </div>
  


  <div v-for="(slug,i) in translationsLookup" v-if="slug.category !== 'identifier' && slug.validation !== 'hidden'" :key="slug.slug">
  <h3 class="my-4 mt-16 font-medium" v-if="false /*translationsLookup[i-1].category !== slug.category*/">{{ getCategoryName(slug.category) }}</h3>
  <vx-card @click="formsDisabled ? customizeThis() : () => {}" :class="{'cursor-pointer': formsDisabled}"  class="mb-6" >
    <h5 class="mb-4">{{ slug.label }}</h5>
    <div class="vx-row">      
      <div class="vx-col md:w-1/2 w-full my-2">
        <h6 class="text-light">Original (english)</h6>
        <p class="mt-5 text-xl text-primary italic">{{slug.english}}</p>        
      </div>
      <div class="vx-col md:w-1/2 w-full my-2">        
      <h6 class="text-light mb-3">Modified</h6>
        <vs-input  :disabled="formsDisabled" v-model="translations[translationI][slug.slug]" v-validate="slug.validation"  data-vv-as="above" :name="slug.slug" placeholder="Enter custom language" class="w-full" />
        <span v-if="slug.slug === 'welcomeSubmitVideo' && translations[translationI][slug.slug].indexOf('$100') === -1" class="text-danger block mt-2">This translation must contain the phrase "$100".</span>                
        <span class="text-danger block mt-2">{{ errors.first(slug.slug) }}</span>                
        <p class="text-sm">{{slug.desc}}</p>
      </div>      
    </div>
  </vx-card>
  </div>

  <savebutton submitText="Apply Language" :accept="update" :goodToGo="formReady" />
</div>
</template>


<script>
import vSelect from 'vue-select'
import Savebutton from './components/ptcomponents/Savebutton.vue'
import Pagesubtitle from './components/ptcomponents/Pagesubtitle.vue'
import translationsLookup from './langlookup/index'

export default {
  data() {
    return {
      setupData: false,
      componentKey: 0,
      translations: [],
      translationsLookup: [],
      translationI: 0
    }
  },
  methods: {
    getCategoryName (code) {
      switch (code) {
        case 'contactquestion':
          return 'Contact Details Question'
        break
        case 'emails':
          return 'Emails'
        break
        case 'embedssharing':
          return 'Widgets and Social Media'
        break
        case 'openquestion':
          return 'Open Answer Question'
        break
        case 'ratingquestions':
          return 'Rating Questions'
        break
        case 'sharequestion':
          return 'Share & Review Question'
        break
        case 'surveygeneral':
          return 'General Survey Text'
        break
        case 'testimonial':
          return 'Testimonial Question'
        break
        case 'texts':
          return 'Texts/SMS'
        break
        case 'thankyoupage':
          return 'Thank you page'
        break
        case 'video':
          return 'Video Responses'
        break
        case 'videobuttons':
          return 'Video Response Buttons'
        break
        case 'welcomepage':
          return 'Welcome Page'
        break
        case 'referralstep':
          return 'Referral Question'
        break
        case 'referralclaim':
          return 'Referral Claim Page'
        break
        case 'referralemails':
          return 'Referral Emails'
        break
        default: return ''
      }
    },
    customizeThis () {

      //check if there isn't already a custom version
      let isAlready = false

      this.translations.forEach((item, i) => {
        if (item.language === (this.translations[this.translationI].language + '_custom_' + this.$store.state.dash.viewData.business.businessID) && item.isCustom) {
          isAlready = i
        }
      });

      if (isAlready !== false) {
        this.translationI = isAlready
        return
      }

      //clone the current one and add i, and iscustom and new name
      this.translations.push({
        ...this.translations[this.translationI],
        isCustom: true,
        name: this.translations[this.translationI].name + ' Customised (' + this.$store.state.dash.viewData.business.businessName + ')',
        language: this.translations[this.translationI].language + '_custom_' + this.$store.state.dash.viewData.business.businessID,
        i: this.translations.length
      })

      this.translationI = this.translations.length - 1

    },
    initInitialData () {

      const newBuild = {}
      translationsLookup().forEach((thing) => {
        newBuild[thing.slug] = 'string'
      })
      //noconsoleconsole.log('nb')
      //noconsoleconsole.log(newBuild)



      //load everything from vuex

      //noconsoleconsole.log('initialising')

      //localize store language packs
      this.translations = [...this.$store.getters['dash/officialTranslations']]

      //custom packs are frozen clones — they never received keys added to the official packs
      //AFTER they were cloned (e.g. the referral step's). Backfill missing keys from the
      //matching official base pack so new fields show translated defaults instead of empty
      //required inputs; the backfill only persists when the user saves.
      const officialByLang = {}
      this.translations.forEach((pack) => { officialByLang[pack.language] = pack })
      const customs = this.$store.getters['dash/customTranslations'].map((pack) => {
        const base = officialByLang[(pack.language || '').split('_custom_')[0]]
        return base ? { ...base, ...pack } : pack
      })
      this.translations = [...this.translations, ...customs]

      //assign the slug lookup table:
      this.translationsLookup = translationsLookup()

      //assign an index to each language pack
      this.translations.forEach((item, i) => {
          if (item.language === this.$store.getters['dash/currentLanguagePackName']) {
            this.translationI = i
          }
          item.i = i
      })

      this.setupData = JSON.stringify({
        translations: this.translations,
        translationI: this.translationI
      })

    },
    update() {

      let theFunction = (allMulties) => {
        this.$store.dispatch('dash/UPDATE_LANGUAGE', {
          allMulties: allMulties,
          translation: this.translations[this.translationI]
        }).then(() => {
          this.initInitialData()
          this.$vs.notify({
            title: 'Apply custom translation',
            text: 'Translation applied successfully',
            color: 'success',
            time: 8000,
            iconPack: 'feather',
            icon: 'icon-check'
          })
        }).catch(() => {
          this.$vs.notify({
            title: 'Apply custom translation',
            time: 10000,
            text: 'Oops! Something went wrong, and we couldn\'t update your translation. Please try again, and reach out for support if it happens again.',
            color: 'warning',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })
        })
      }

      let theFunctionMulties = () => {
        theFunction(true)
      }

      let theFunctionSingle = () => {
        theFunction(false)
      }

      if (this.$store.state.dash.isMulti) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'primary',
          title: `Multiple spaces`,
          text: 'Would you like to set this as the language pack for all spaces?',
          acceptText: 'Yes',
          cancelText: 'No',
          accept: theFunctionMulties,
          cancel: theFunctionSingle
        })
      } else {
        theFunction(false)
      }

    },
  },
  watch: {
    '$store.state.dash.currentMultiLocationI' (v) {
      if (!this._inactive) {
        this.initInitialData()
        this.componentKey++
      }
    }
  },
  computed: {
    formsDisabled () {
      return (!this.translations[this.translationI].isCustom)
    },
    isCurrentSelection() {
      let lookForCustom = this.$store.getters['dash/currentLanguagePackName'].indexOf('_custom') !== -1

      if (lookForCustom) {
        if (this.translations[this.translationI].isCustom && (this.translations[this.translationI].language === this.$store.getters['dash/currentLanguagePackName'].replace('_custom',''))) {
          return true
        }
      } else {
        if (this.translations[this.translationI].language === this.$store.getters['dash/currentLanguagePackName']) {
          return true
        }
      }
      return false
    },
    formReady() {
      if (this.setupData === JSON.stringify({
          translations: this.translations,
          translationI: this.translationI
        })) {
        return false
      } else {
        if (this.errors.any()) return false
      }
      return true
    }
  },
  components: {
    Savebutton,
    Pagesubtitle,
    'v-select': vSelect
  },
  created() {
    //noconsoleconsole.log('INITIALISING')
    if (!this._inactive) {
      this.initInitialData()
    }
  }
}
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
    .greet-user {
        position: relative;

        .decore-left {
            position: absolute;
            left: 0;
            top: 0;
        }
        .decore-right {
            position: absolute;
            right: 0;
            top: 0;
        }
    }

    @media(max-width: 576px) {
        .decore-left,
        .decore-right {
            width: 140px;
        }
    }
}
/*! rtl:end:ignore */
</style>
